import { AppRole, AuthStatusResult, User, UserType } from '../../types/auth';

export function parsePositiveUserId(raw: unknown): number | undefined {
  const n = typeof raw === 'number' ? raw : Number(raw);
  if (Number.isInteger(n) && n > 0) {
    return n;
  }
  return undefined;
}

export function mapAuthStatusUser(raw: unknown): User | null {
  if (raw === null || typeof raw !== 'object') {
    return null;
  }

  const record = raw as Record<string, unknown>;
  const idRaw = record.id ?? record.sub;
  const id =
    typeof idRaw === 'string' ? idRaw : idRaw != null ? String(idRaw) : '';
  const name = typeof record.name === 'string' ? record.name : '';
  const email = typeof record.email === 'string' ? record.email : '';
  const phone = typeof record.phone === 'string' ? record.phone : '';
  const userType: UserType =
    record.userType === 'external' ? 'external' : 'internal';
  const adGroups = Array.isArray(record.adGroups)
    ? record.adGroups.filter((g): g is string => typeof g === 'string')
    : [];
  const roles = Array.isArray(record.roles)
    ? (record.roles.filter(
        (r): r is string => typeof r === 'string',
      ) as AppRole[])
    : [];

  const user: User = {
    id,
    name,
    email,
    phone,
    userType,
    adGroups,
    roles,
  };

  const userId = parsePositiveUserId(record.user_id);
  if (userId !== undefined) {
    user.userId = userId;
  }

  return user;
}

export function authStatusFromHttp(args: {
  httpStatus: number;
  ok: boolean;
  body: unknown;
}): AuthStatusResult {
  const { httpStatus, ok, body } = args;
  if (httpStatus === 401 || httpStatus === 403 || httpStatus === 404) {
    return { kind: 'anonymous' };
  }
  if (!ok || httpStatus === 0 || httpStatus === 429 || httpStatus >= 500) {
    return { kind: 'error' };
  }

  if (typeof body !== 'object' || body === null) {
    return { kind: 'error' };
  }

  const record = body as Record<string, unknown>;
  const isAuthenticated = record.isAuthenticated === true;
  const success = record.success === true;

  if (success && isAuthenticated && record.user) {
    const user = mapAuthStatusUser(record.user);
    if (!user) {
      return { kind: 'error' };
    }
    return { kind: 'user', user };
  }

  if (success && isAuthenticated && !record.user) {
    return { kind: 'error' };
  }

  if (ok && httpStatus === 200 && !isAuthenticated) {
    return { kind: 'anonymous' };
  }

  return { kind: 'error' };
}
